/**
 * Canvas view
 * @class CustomDesignCanvas
 * @requires {@link http://raphaeljs.com| Raphael js }
 * @requires {@link https://github.com/AliasIO/Raphael.FreeTransform| Free Transform plugin for Raphael js }
 * @requires {@link http://underscorejs.org/| underscorejs.org }
 */
window.CustomDesignCanvas = function () {

	this.getPaper = function () {

		return paper;

	};

	/** @private */
	const that = this;
	var paper = null;
	const $events = $(qtee.customDesign);
	let _prevEvents;

	/** @public */
	this.elements = [];
	this.defaultSize = 200;

	/**
	 * Callback function that is invoked everytime when any transformation happend (like init, drag, rotate, scale)
	 * We use this function to send message to View to update controls, save models and etc
	 * @private
	 * @param {FreeTransform object} ft
	 * @param {array} events
	 */
	function _callbackTransformation (ft, events) {

		$(qtee.customDesign).triggerHandler('showSuccessState', events.join(','));
		// check if at least one event from events array exists in the qtee.customDesign.settings.onSaveEvents array
		// and at least one event in the _prevEvents exists in the qtee.customDesign.settings.preEvent array
		const isSaveEvent =			events
			&& events.some((event) => qtee.customDesign.settings.onSaveEvents.some(
				(saveEvent) => saveEvent.event.test(event) && _prevEvents.some((prev) => saveEvent.preEvent.test(prev))
			));

		_prevEvents = events;
		if (isSaveEvent) {

			$events.triggerHandler('transformed.elements.canvas', that.getElementById(ft.subject.id).element);

		}

	}

	/**
	 * Reset canvas
	 */
	this.resetCanvas = function () {

		paper.clear();
		this.elements = [];

	};

	/**
	 * Select element by id
	 * Invoke this function with non existing id like -1 to deselect
	 * @param {Integer} id
	 */
	this.selectElement = function (id) {

		// hide free transform for prev element
		const prevSelectedEl = this.getSelected();
		if (prevSelectedEl) {

			prevSelectedEl.element.hideBoundingBox();
			// send the event to update view's controls
			$events.triggerHandler('deselected.elements.canvas', prevSelectedEl);

		}

		const newSelectedEl = this.getElementById(id);
		if (newSelectedEl) {

			newSelectedEl.element.showBoundingBox();
			// send the event to update view's controls
			$events.triggerHandler('selected.elements.canvas', newSelectedEl);

		}

	};

	/**
	 * Get selected element
	 * Note: actually this method return first element with bounding box, it should be a selected element
	 * @return {Object|false} object with two properties 'element' and 'index'
	 */
	this.getSelected = function () {

		for (let i = 0; i < this.elements.length; i++) {

			if (
				this.elements[i].freeTransform
				&& this.elements[i].freeTransform.bbox != null
				&& this.elements[i].freeTransform.bbox.node.style.display !== 'none'
			) {

				return { element: this.elements[i], index: i };

			}

		}

		return false;

	};

	/**
	 * Get background element
	 * @return {Object|false} object with two properties 'element' and 'index'
	 */
	this.getBackground = function () {

		for (let i = 0; i < this.elements.length; i++) {

			if (this.elements[i].isBackground || this.elements[i].zIndex == 0) {

				return { element: this.elements[i], index: i };

			}

		}

		return false;

	};

	/**
	 * Return if box is outside window
	 */

	this.isOutside = function (attrs) {

		const { width } = attrs;
		const { height } = attrs;
		const el = this.getSelected() || false;
		const values = el ? el.element.rel.freeTransform.bbox.attrs.path : false;

		if (values) {

			for (let i = 0; i < values.length; i++) {

				if (values[i][1] < 0 || values[i][1] > width || values[i][2] < 0 || values[i][2] > height) {

					return true;

				}

			}

		}

		return false;

	};

	/**
	 * Add new element to scene
	 * @param {Backbone.Model} model
	 * @param {Boolean} autoselect
	 */
	this.add = function (model, autoselect = true, isBackground = false) {

		$events.triggerHandler('adding.elements.canvas', model);

		// create element
		return qtee.customDesign.elementFactory
			.createElement(model, paper, _callbackTransformation)
			.ready()
			.then(
				(element) => {

					if (isBackground) {

						const elIndex = _.findIndex(this.elements, { zIndex: 0 });
						const prevBgCid = this.elements && this.elements[elIndex] ? this.elements[elIndex].cid : null;
						const prevBgModel = prevBgCid ? model.collection.get({ cid: prevBgCid }) : null;

						if (prevBgModel && elIndex >= 0) {

							// remove existing backgrounds
							this.removeElementByIndex(elIndex);
							prevBgModel.trigger('destroy', prevBgModel);

						}

						// set z-index if it's new element (it's not from backend), and set isBackground to true
						if (undefined == element.zIndex || element.zIndex > 0) {

							element.zIndex = 0;
							element.isBackground = true;

						}

						// add element to array of elements
						this.elements.push(element);
						// reorder all elelments and their positions on the Paper according their zIndex
						this.reOrder();

						// add event handler to element
						if (qtee.customDesign.settings.isTouch()) {

							element.rel.touchstart((e) => {

								e.stopPropagation();
								this.selectElement(-1);

							});

						} else {

							element.rel.mousedown((e) => {

								e.stopPropagation();
								this.selectElement(-1);

							});

						}

						// since only one element allowed to be with bounding box we hide it for new elements
						element.hideBoundingBox();

						$events.triggerHandler('deselected.elements.canvas');

					} else {

						// set z-index if it's new element (it's not from backend)
						if (undefined == element.zIndex) {

							element.zIndex = this.getMaxZIndex() + 1;

						}

						// add element to array of elements
						this.elements.push(element);
						// reorder all elelments and their positions on the Paper according their zIndex
						this.reOrder();

						// add event handler to element
						if (qtee.customDesign.settings.isTouch()) {

							element.rel.touchstart((e) => {

								e.stopPropagation();
								this.selectElement(element.id);

							});

						} else {

							element.rel.mousedown((e) => {

								e.stopPropagation();
								this.selectElement(element.id);

							});

						}

						// since only one element allowed to be with bounding box we hide it for new elements
						element.hideBoundingBox();

						// display handles upon adding
						if (autoselect) {

							this.selectElement(element.id);

						}

					}

					$events.triggerHandler('addSuccess.elements.canvas', element);

					return element;

				},
				(failReason) => {

					$events.triggerHandler('addFail.elements.canvas', failReason);
					throw new Error(failReason);

				}
			);

	};

	/** Initialize paper */
	this.initScene = function () {

		// if paper already was created
		if (paper && paper.canvas && paper.canvas.parentNode) {

			paper.canvas.parentNode.removeChild(paper.canvas);
			paper = undefined;

		}

		paper = Raphael('customDesignCanvas');
		paper.canvas.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
		// add click event to the SVG element to allow deselect elements by clicking on the background
		$(paper.canvas)
			.on(qtee.customDesign.settings.isTouch() ? 'touchstart' : 'click', (e) => {

				if (e.target.nodeName.toLowerCase() === 'svg') {

					// deselect selected element
					that.selectElement(undefined);

				}

			})
			.css({ position: 'absolute' });

	};

	/**
	 * Render the scene based on provided model
	 * @param {Backbone Model} model
	 * @param {Boolean} reinit - to reinit Scene
	 * @return {Promise} resolved when all elements are rendered, reject
	 */
	this.renderScene = function (model, reinit) {

		$events.triggerHandler('renderStart.canvas');

		if (!paper || reinit) {

			this.initScene();

		}

		if (model.area) {

			// update background image
			const p = new Promise((resolve, reject) => {

				const $wrp = $(paper.canvas).parent();
				const newSrc = `${model.area.BackgroundImageUrl}&wid=${$wrp.width()}` || '';
				const oldSrc = $wrp.css('background-image').split('"')[1];

				// no needs to change background if it's same
				if (newSrc != oldSrc) {

					// if old background was not set up
					if (!oldSrc) {

						$wrp.css('background-image', `url("${newSrc}")`);
						resolve();

					} else {

						$wrp.fadeTo(500, 0, () => {

							const imgSwap = new Image();
							imgSwap.onerror = () => {

								reject('Background image was not loaded');

							};
							imgSwap.onload = () => {

								$wrp.css('background-image', `url("${newSrc}")`).fadeTo(300, 1);
								resolve();

							};
							imgSwap.src = newSrc;

						});

					}

				} else {

					resolve();

				}

			});

			// set working area
			$(paper.canvas).css({
				top: model.area.OriginY,
				left: model.area.OriginX
			});
			paper.setSize(model.area.Width, model.area.Height);
			// resets entire canvas
			this.resetCanvas();

			const promises = [ p ];
			for (const collection in model.elements) {

				model.elements[collection].forEach((elModel) => {

					let isBackground = false;

					if (elModel.get('IsBackground') || elModel.get('ZOrder') === 0) {

						elModel.set('IsBackground', true);
						isBackground = true;

					}

					promises.push(this.add(elModel, false, isBackground));

				});

			}

			return Promise.all(promises).then(
				() => {

					$events.triggerHandler('renderSuccess.canvas');

				},
				(r) => {

					$events.triggerHandler('renderFail.canvas', r);
					return Promise.reject(r);

				}
			);

		}
		$events.triggerHandler('renderFail.canvas', 'Area is not provided');
		return Promise.reject('Area is not provided');

	};

	/**
	 * Return minimuz z index if we have at least one element otherwise return 0
	 */
	this.getMinZIndex = function () {

		const z = this.elements.reduce((a, b) => Math.min(a, b.zIndex), Infinity);
		return isFinite(z) ? z : 0;

	};

	/**
	 * Return maximum z index if we have at least one element otherwise return 0
	 */
	this.getMaxZIndex = function () {

		const z = this.elements.reduce((a, b) => Math.max(a, b.zIndex), -Infinity);
		return isFinite(z) ? z : 0;

	};

	/**
	 * Return true if element on the back, behind of the rest elements
	 * @param {Element} element
	 */
	this.isElementOnBack = function (element) {

		// z-index of element
		const curz = element.zIndex;

		return !this.elements.some((el) => {

			if (el.zIndex < curz && el.zIndex > 0) {

				return true;

			}
			return false;

		});

	};

	/**
	 * Return true if element on the front, on top of the rest elements
	 * @param {Element} element
	 */
	this.isElementOnFront = function (element) {

		// z-index of element
		const curz = element.zIndex;

		return !this.elements.some((el) => {

			if (el.zIndex > curz && el.zIndex > 0) {

				return true;

			}
			return false;

		});

	};

	/**
	 * Reorder all elelments and their position in the paper according their zIndex
	 */
	this.reOrder = function () {

		if (this.elements.length > 0) {

			this.elements
				.sort((a, b) => a.zIndex - b.zIndex)
				.forEach((element) => {

					element.rel.toFront();

				});

		}

	};

	/**
	 * Move selected element one step forward
	 */
	this.moveUpSelected = function () {

		const // selected element that will be brought one step forward
			el = this.getSelected();
		// array of elements before selected element
		let elementsBefore;
		// current z-index of selected element
		let curZ;
		// element right before selected element
		let exchangeEl;

		// return if user didn't select any element
		if (!el) {

			return;

		}

		// save current z-index of selected element
		(curZ = el.element.zIndex), // select all elements that before selected element and sort them by z-index
		(elementsBefore = this.elements.filter((a) => a.zIndex > curZ).sort((a, b) => a.zIndex - b.zIndex));

		// return if we don't have elements before selected element (selected element in front of scene)
		if (elementsBefore.length == 0) {

			return;

		}

		// exchange z-index for selected element and element right before it
		exchangeEl = elementsBefore.shift();
		el.element.zIndex = exchangeEl.zIndex;
		exchangeEl.zIndex = curZ;

		// move selected element to front
		el.element.rel.toFront();

		// move the rest of elements that should be before selected element to front
		elementsBefore.forEach((a) => {

			a.rel.toFront();

		});

		// bounding box should be always on top
		el.element.freeTransform.updateHandles();

		$events.triggerHandler('orderChanged.elements.canvas', { el, exEl: this.getElementById(exchangeEl.id) });

	};

	/**
	 * Move selected element on step back
	 */
	this.moveDownSelected = function () {

		const // selected element that will be brought one step back
			el = this.getSelected();
		// array of elements after selected element
		let elementsAfter;
		// current z-index of selected element
		let curZ;
		// element right after selected element
		let exchangeEl;

		// return if user didn't select any element
		if (!el) {

			return;

		}

		// save current z-index of selected element
		curZ = el.element.zIndex;

		// select all elements that after selected element and then make reverse sort by z-index
		elementsAfter = this.elements.filter((a) => a.zIndex < curZ).sort((a, b) => b.zIndex - a.zIndex);

		// return if we don't have elements after selected element (selected element in back of scene)
		if (elementsAfter.length == 0) {

			return;

		}

		// exchange z-index for selected element and element right before it
		exchangeEl = elementsAfter.shift();
		el.element.zIndex = exchangeEl.zIndex;
		exchangeEl.zIndex = curZ;

		// move selected element to back
		el.element.rel.toBack();

		// move the rest of elements that should be after selected element to back
		elementsAfter.forEach((a) => {

			a.rel.toBack();

		});

		// bounding box should be always on top
		el.element.freeTransform.updateHandles();

		$events.triggerHandler('orderChanged.elements.canvas', { el, exEl: this.getElementById(exchangeEl.id) });

	};

	/**
	 * Return element by index
	 * @param {Integer} i index of element
	 */
	this.getElementByIndex = function (i) {

		return this.elements[i];

	};

	/** Return first element that match attrs */
	this.getElement = function (attrs) {

		return _.findWhere(this.elements, attrs);

	};

	/** Return first index of element that match attrs */
	this.getIndex = function (attrs) {

		return _.findIndex(this.elements, _.isMatch(attrs));

	};

	/** Remove first element that match attrs */
	this.removeElement = function (attrs) {

		const i = this.getIndex(attrs);
		if (i >= 0) {

			return this.removeElementByIndex(i);

		}
		return false;

	};

	/**
	 * Remove element by index
	 * @param {Integer} i index
	 * @return {Boolean} true we have found element with index i and remove it from scene and false otherwise
	 */
	this.removeElementByIndex = function (i) {

		const el = this.elements[i];

		if (el) {

			// deselect element
			this.selectElement(-1);

			// remove element
			el.remove();
			this.elements.splice(i, 1);
			$events.triggerHandler('removed.elements.canvas');
			return true;

		}

		return false;

	};

	/**
	 * Return Object with element and its index from array of elements (this.elements) by element's id
	 * @param {Integer} id
	 * @return {Object|false} object with two fields 'element' and 'index'
	 */
	this.getElementById = function (id) {

		const element = this.getElement({ id });
		const index = this.getIndex({ id });

		return element ? { element, index } : false;

	};

	/**
	 * Return Object with element and its index from array of elements (this.elements) by element's sid
	 * @param {String} sid
	 * @return {Object|false} object with two fields 'element' and 'index'
	 */
	this.getElementBySid = function (sid) {

		const element = this.getElement({ sid });
		const index = this.getIndex({ sid });

		return element ? { element, index } : false;

	};

	/**
	 * Return all elements with the same type
	 * @param {string} type
	 * @return {array}
	 */
	this.getAllElementsByType = function (type) {

		return this.elements.filter((el) => type == el.type);

	};

	/**
	 * Return array of empty text elements
	 */
	this.getEmptyTextElements = function () {

		const elements = [];
		for (let i = 0; i < this.elements.length; i++) {

			if (this.elements[i].type == 'text' && this.elements[i].isEmpty()) {

				elements.push({ element: this.elements[i], index: i });

			}

		}

		return elements;

	};

	/**
	 * Remove all empty text elements from canvas
	 */
	this.removeEmptyTextElements = function () {

		for (let i = 0; i < this.elements.length; i++) {

			if (this.elements[i].type == 'text' && this.elements[i].isEmpty()) {

				this.removeElementByIndex(i);

			}

		}

	};

	/**
	 * Remove selected element
	 * @return {Boolean} true if we have found element and remove it from the scene and false if there was no selected element
	 */
	this.removeSelectedElement = function () {

		const el = this.getSelected();
		if (el) {

			return this.removeElementByIndex(el.index);

		}

		return false;

	};

};
